// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__9Wlfv"};
module.exports.__checksum = "ac619a1defba"
